import { Box, Paper, Typography } from "@mui/material";
import { colors, elevation, borderRadius, spacing } from "../../theme";
import { DuplicateAuditSummary } from "../../types/duplicateAudit";

interface Props {
  summary: DuplicateAuditSummary | null;
}

export default function AuditSummaryTiles({ summary }: Props) {
  const tiles = [
    { label: "Filtered results", value: summary?.totalCount },
    { label: "Awaiting review", value: summary?.pendingCount },
    { label: "Critical risk (95%+)", value: summary?.criticalCount },
  ];

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
        gap: spacing.mui.lg,
      }}
    >
      {tiles.map((tile) => (
        <Paper
          key={tile.label}
          elevation={elevation.low}
          sx={{
            p: spacing.mui.lg,
            borderRadius: borderRadius.mui.medium,
            borderLeft: `5px solid ${colors.primary.main}`,
          }}
        >
          <Typography variant="h4" fontWeight={700}>
            {tile.value ?? "-"}
          </Typography>
          <Typography variant="body2" color={colors.text.secondary}>
            {tile.label}
          </Typography>
        </Paper>
      ))}
    </Box>
  );
}
